import { Alert, Button, Link, Stack, Typography } from '@mui/material';
import { FileAttachment04 } from 'untitledui-js-base';
import { formatPrice } from '../../utils/formatPrice';
import { BasicDialog } from '../common/BasicDialog';
import { SourceNameCell } from './SourceNameCell';
import { CreateSourceCommissionDocumentsResult } from './type/sourceCommissions';
import { withCacheBuster } from './utils';

interface CreateResultDialogProps {
  result?: CreateSourceCommissionDocumentsResult;
  onClose: () => void;
}

export const CreateResultDialog = ({ result, onClose }: CreateResultDialogProps) => (
  <BasicDialog open={!!result} onClose={onClose} title="Výsledek vystavení" fullWidth maxWidth="sm">
    <Stack gap={2}>
      {result?.failed.length ? (
        <Alert severity="warning">
          Tyto POJ se nepodařilo vyplatit (už jsou vyplacené nebo mají neplatnou částku): {result.failed.join(', ')}.
        </Alert>
      ) : null}
      {result?.documents.length ? (
        result.documents.map((doc) => (
          <Stack key={doc.id} direction="row" justifyContent="space-between" alignItems="center" gap={2}>
            <Stack>
              <Typography fontWeight={600}>{doc.documentNumber}</Typography>
              <SourceNameCell name={doc.sourceName} tradeName={doc.sourceTradeName} />
              <Typography variant="body2" color="text.secondary">
                {formatPrice(doc.totalPrice, 2)} · položek: {doc.itemsCount}
              </Typography>
            </Stack>
            {doc.pdf ? (
              <Link href={withCacheBuster(doc.pdf) ?? doc.pdf} target="_blank" underline="always">
                <Stack direction="row" alignItems="center" gap={0.5}>
                  <FileAttachment04 size="14px" /> Stáhnout PDF
                </Stack>
              </Link>
            ) : (
              <Typography variant="body2" color="text.secondary">
                PDF není k dispozici
              </Typography>
            )}
          </Stack>
        ))
      ) : (
        <Typography>Nevznikl žádný doklad.</Typography>
      )}
      <Button onClick={onClose} variant="contained">
        Zavřít
      </Button>
    </Stack>
  </BasicDialog>
);
